/* eslint-disable react/prop-types */
import { ArrowDownIcon, ArrowUpIcon, RotateCcwIcon } from "lucide-react";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "antd";
export default function TransactionTimeline({ transactions = [] }) {
    const navigate = useNavigate();
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Transaction Timeline</h1>
      <div className="relative">
        {transactions.map((entry) => (
          <div
            key={entry._id || entry.refundId}
            className="mb-8 flex gap-2 items-center w-full"
          >
            <div className="z-20 flex items-center order-1 bg-gray-800 shadow-xl w-8 h-8 rounded-full">
              <span className="mx-auto font-semibold text-lg text-white">
                {entry.entry_type === "refund" ? (
                  <ArrowDownIcon className="w-5 h-5 text-red-400" />
                ) : entry.type === 1 ? (
                  <ArrowUpIcon className="w-5 h-5 text-green-400" />
                ) : (
                  <ArrowDownIcon className="w-5 h-5 text-red-400" />
                )}
              </span>
            </div>
            {entry.entry_type === "refund" ? (
              <div className="order-1 w-full bg-gray-100 rounded-lg shadow-xl px-6 py-4">
                <h3 className="mb-3 font-bold text-gray-800 text-xl">
                  <span className="text-red-600">{entry.refundType === "full" ? "Full Refund" : "Partial Refund"} {entry.partsRefunded} Shares</span>
                </h3>
                <p className="text-sm text-gray-600 leading-snug">
                  Date: {entry.t ? dayjs(entry.t).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
                </p>
                <p className="text-sm font-mono leading-snug truncate">
                  Hash: <Link to={"/tx/" + (entry.transaction_hash || entry.transaction_reference_id || entry.refundId)}>{entry.transaction_hash || entry.transaction_reference_id || entry.refundId}</Link>{" "}
                  {(entry.transaction_hash || entry.transaction_reference_id || entry.refundId) && <Button onClick={() => navigate("/tx/" + (entry.transaction_hash || entry.transaction_reference_id || entry.refundId))} size="small" type="primary">Details</Button>}
                </p>
              </div>
            ) : (
              <div className="order-1 w-full bg-gray-100 rounded-lg shadow-xl px-6 py-4">
                <h3 className="mb-3 font-bold text-gray-800 text-xl">
                  {entry.type === 1 ? (
                    <span className="text-green-600">Buy</span>
                  ) : (
                    <span className="text-red-600">Sell</span>
                  )}{" "}
                  {entry.shares_number} Shares
                </h3>
                <p className="text-sm text-gray-600 leading-snug">
                  Date: {dayjs(entry.t).format("YYYY-MM-DD HH:mm:ss")}
                </p>
                <p className="text-sm font-mono leading-snug truncate">
                  Hash: <Link to={"/tx/" + entry.hash}>{entry.hash}</Link> <Button onClick={() => navigate("/tx/" + entry.hash)} size="small" type="primary">Details</Button>
                </p>
              </div>
            )}
          </div>
        ))}
        
      </div>
    </div>
  );
}
